// store/modules/ui.js


import * as types from '../mutation-types';


// State object
export const state = {
    isSidebarOpen: true,
    isMobile: false,
    isSidebarCollapsed: localStorage.getItem('sidebarCollapsed') === 'true',
};

// Getters
export const getters = {
    isSidebarOpen: state => state.isSidebarOpen,
    isMobile: state => state.isMobile,
    isSidebarCollapsed: state => state.isSidebarCollapsed,
};

// Mutations
export const mutations = {
    [types.TOGGLE_SIDEBAR](state) {
        state.isSidebarOpen = !state.isSidebarOpen;
    },

    [types.SET_SIDEBAR_OPEN](state, isOpen) {
        state.isSidebarOpen = isOpen;
    },

    [types.ENABLE_MOBILE](state) {
        state.isMobile = true;
    },

    [types.SET_SIDEBAR_COLLAPSED](state, collapsed) {
        state.isSidebarCollapsed = collapsed;
        localStorage.setItem('sidebarCollapsed', collapsed);
    },
};

// Actions
export const actions = {
    toggleSidebar({ commit }, isOpen) {
        if (typeof isOpen === 'boolean') {
            commit(types.SET_SIDEBAR_OPEN, isOpen);
        } else {
            commit(types.TOGGLE_SIDEBAR);
        }
    },

    enableMobile({ commit }) {
        commit(types.ENABLE_MOBILE);
    },

    setSidebarCollapsed({ commit }, collapsed) {
        commit(types.SET_SIDEBAR_COLLAPSED, collapsed);
    },
};
